import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/pagination';

import mockup1 from '../assets/images/pilari-app-1.jpg';
import mockup2 from '../assets/images/pilari-app-2.jpg';
import mockup3 from '../assets/images/pilari-app-3.jpg';
import mockup4 from '../assets/images/pilari-app-4.jpg';
import mockup5 from '../assets/images/pilari-app-5.jpg';
import mockup6 from '../assets/images/pilari-app-6.jpg';
import mockup7 from '../assets/images/pilari-app-7.jpg';
import mockup8 from '../assets/images/pilari-app-8.jpg';

const mockups = [
  mockup1, mockup2, mockup3, mockup4,
  mockup5, mockup6, mockup7, mockup8
];

const ShowcaseSection = () => {
  const { t } = useTranslation();
  const [isClient, setIsClient] = useState(false);
  const shouldLoop = mockups.length >= 5;

  useEffect(() => {
    setIsClient(true); // avoid hydration mismatch
  }, []);

  return (
    <section
      id="showcase"
      className="bg-white dark:bg-gray-900 py-24 px-4 md:px-10 text-center snap-start"
    >
      <h2
        className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-white"
        data-aos="fade-up"
      >
        {t('showcase.title')}
      </h2>
      <p
        className="text-gray-600 dark:text-gray-300 mb-14 text-sm max-w-xl mx-auto"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        {t('showcase.subtitle')}
      </p>

      <div className="max-w-6xl mx-auto px-2">
        {isClient && (
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={16}
            loop={shouldLoop}
            slidesPerGroup={1}
            breakpoints={{
              0: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="!pb-12"
          >
            {mockups.map((img, idx) => (
              <SwiperSlide key={idx}>
                <div
                  className="w-full h-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-[2rem] p-4 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
                  data-aos="zoom-in"
                  data-aos-delay={idx * 150}
                >
                  <img
                    src={img}
                    alt={`Mockup ${idx + 1}`}
                    className="rounded-xl w-full h-auto object-cover"
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </section>
  );
};

export default ShowcaseSection;
